import {
  SYPI_S3,
  SYPI_SERVER_SETTINGS,
  SYPI_DB,
  CONFIG_SCHEDULER,
  SYPI_LEGACY,
  GlobalActionType,
} from "@actions/types";

export const getActionBaseOnFeature = (type: GlobalActionType, feature?: string): string => {
  switch (feature) {
    case SYPI_S3:
      return `${SYPI_S3}_${type}`;
    case SYPI_SERVER_SETTINGS:
      return `${SYPI_SERVER_SETTINGS}_${type}`;
    case SYPI_DB:
      return `${SYPI_DB}_${type}`;
    case SYPI_LEGACY:
      return `${SYPI_LEGACY}_${type}`;
    case CONFIG_SCHEDULER:
      return `${CONFIG_SCHEDULER}_${type}`;
    default:
      return type;
  }
};
